// RAG routes - imported by routesConfig.jsx ONLY after activation (see the
// "RAG ACTIVATION" markers there). Until then nothing imports this file, so webpack
// does not bundle it or the RAG pages, and /rag + /chat do not exist.
//
// Activation is two steps: (1) REACT_APP_ENABLE_RAG=true in the build env, and
// (2) uncomment the import + {ragRoutes()} in routesConfig.jsx. The RAG_ENABLED guard
// below is a second belt-and-suspenders switch so the routes stay off if the flag is
// somehow unset even after the import is uncommented.
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import ProtectedRoute from "../components/Shared/ProtectedRoute.jsx";
import { RAG_ENABLED } from "./featureFlags";

const RagPage = React.lazy(() => import("../components/Rag/RagPage.jsx"));
const ChatPage = React.lazy(() => import("../components/Rag/ChatPage.jsx"));
const AssessmentPage = React.lazy(() =>
  import("../components/Rag/AssessmentPage.jsx")
);

const fallback = (
  <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
    <CircularProgress />
  </Box>
);

// Returns the RAG <Route> elements (or null when disabled) to spread into <Routes>.
// All three require a logged-in user. There is no /signup: self-serve registration is
// deliberately out of v1 (plan decision D12), so accounts are created by an
// administrator and the public surface stays closed.
//
// /assessment is the surface people are given; /rag (the raw CLI-flag form) and /chat
// (a bare conversation over ?trace=) stay reachable as operator entry points.
export const ragRoutes = () =>
  RAG_ENABLED
    ? [
        <Route
          key="assessment"
          path="/assessment"
          element={
            <ProtectedRoute>
              <Suspense fallback={fallback}>
                <AssessmentPage />
              </Suspense>
            </ProtectedRoute>
          }
        />,
        <Route
          key="rag"
          path="/rag"
          element={
            <ProtectedRoute>
              <Suspense fallback={fallback}>
                <RagPage />
              </Suspense>
            </ProtectedRoute>
          }
        />,
        <Route
          key="chat"
          path="/chat"
          element={
            <ProtectedRoute>
              <Suspense fallback={fallback}>
                <ChatPage />
              </Suspense>
            </ProtectedRoute>
          }
        />,
      ]
    : null;
